import React, { useState } from 'react';
import { toast } from 'react-toastify';

import MenuIcon from '@mui/icons-material/Menu';
import NotificationsIcon from '@mui/icons-material/Notifications';
import {
  IconButton,
  Drawer,
  Slide,
  Modal,
  Box,
  Typography,
} from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Button from '@mui/material/Button';
import { useTheme } from '@mui/material/styles';
import EmailIcon from '@mui/icons-material/Email';
import AccountCircle from '@mui/icons-material/AccountCircle';
import {
  AccountCircleOutlined,
  AccountCircleTwoTone,
  ChangeCircle,
  Logout,
} from '@mui/icons-material';

import instances from '../../constants/instances';
import { appConfig } from '../../constants/appConfig';
import { websocket_config } from '../../constants/wsConfig';
import Calendar from '../Calendar';
import LanguageIcon from '../langSwitcher';
import logoSmall from '../../assets/images/logosmall.png';
import { useBoundStore } from '../../stores';

function TDrawer({
  open,
  handleDrawerClose,
  handleDrawerOpen,
  logoutMerchant,
  anchor,
  showDrawerHeader,
  children,
}) {
  const theme = useTheme();
  const textPool = useBoundStore((state) => state.textPool);

  const [menuOpen, setMenuOpen] = useState(false);
  const modalOpen = useBoundStore((state) => state.modalOpen);
  const setModalOpen = useBoundStore((state) => state.setModalOpen);
  const setAppConfig = useBoundStore((state) => state.setAppConfig);
  const setWsConfig = useBoundStore((state) => state.setWsConfig);

  const handleInstanceSelection = (selectedInstance) => {
    setAppConfig(appConfig[selectedInstance.config]);
    setWsConfig(websocket_config.url[selectedInstance.config]);
    localStorage.setItem('modalOpen', 'false');
    localStorage.setItem(
      'selectedInstance',
      JSON.stringify([selectedInstance]),
    );
    setModalOpen(false);
    toast.success(
      `${textPool['Uygulamaya yönlendiriliyorsunuz.']} (${selectedInstance.name})`,
    );
    window.location.reload();
  };

  const handleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <>
      <Drawer
        TransitionComponent={Slide}
        transitionDuration={400}
        sx={{
          '& .MuiDrawer-paper': {
            width: '25%',
            [theme.breakpoints.between('md', 'lg')]: {
              width: '45%',
            },
            [theme.breakpoints.between('lg', 'xl')]: {
              width: '35%',
            },
            boxSizing: 'border-box',
            backgroundColor: 'rgba(243, 244, 246,0.8)',
            border: 'none',
            boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
            // [theme.breakpoints.between('md', 'xl')]: {
            //   display: 'none',
            // },
            [theme.breakpoints.down('md')]: {
              width: '100%',
              backgroundColor: '#F3F4F6',
            },
          },
        }}
        open={open}
        onClose={handleDrawerClose}
        variant="temporary"
        anchor={anchor}
      >
        <div className="p-3 m-1">
          {showDrawerHeader && (
            <div
              className={`flex justify-between items-center ${anchor === 'right' ? 'flex-row' : 'flex-row-reverse'
                }`}
            >
              <IconButton onClick={handleDrawerClose}>
                {anchor === 'left' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
              </IconButton>

              <div
                className={` flex justify-end items-center gap-5 ${anchor === 'right' ? 'flex-row' : 'flex-row-reverse'
                  }`}
              >
                <IconButton>
                  <NotificationsIcon />
                </IconButton>
                <LanguageIcon />
                <div
                  onClick={handleMenu}
                  className="flex flex-row bg-gray-50 shadow-md rounded-md p-1 cursor-pointer hover:scale-105 transition ease 1s"
                >
                  <AccountCircle />
                  <div className="flex justify-center items-center w-[150px]">
                    <span className="font-bold text-[12px] ">
                      {JSON.parse(localStorage.getItem('user'))?.username}
                    </span>
                  </div>
                </div>
                <IconButton
                  color="inherit"
                  aria-label="open drawer"
                  edge="end"
                  onClick={handleDrawerOpen}
                  sx={{ ...(open && { display: 'none' }) }}
                >
                  <MenuIcon />
                </IconButton>
              </div>
            </div>
          )}

          {/* <Button
            onClick={() => {
              logoutMerchant();
            }}
            variant="outlined"
            className="w-full mt-5 z-[0]"
          >
            {textPool['ÇIKIŞ YAP']}
          </Button> */}

          {menuOpen && (
            <div className={` gap-2 mt-5 bg-gray-50 shadow-md rounded-md`}>
              <div className="w-full flex flex-row justify-between items-center px-4 py-2 rounded-md gap-3">
                {/* {JSON.parse(localStorage.getItem('instance')).length > 1 && (
                  <div className=" flex flex-row justify-center items-center ">
                    <IconButton
                      onClick={() => {
                        setModalOpen(true);
                        localStorage.setItem('modalOpen', 'true');
                      }}
                    >
                      <ChangeCircle />
                    </IconButton>
                  </div>
                )} */}
                {/* <div className=" flex flex-row justify-center items-center ">
                  {JSON.parse(localStorage.getItem('instance')).length > 1
                    ? JSON.parse(localStorage.getItem('selectedInstance'))[0]
                      .name
                    : // JSON.parse(localStorage.getItem('instance'))[0]?.instance?.id
                    instances.find(
                      (x) =>
                        x.id ===
                        JSON.parse(localStorage.getItem('instance'))[0]
                          ?.instance?.id,
                    )?.name}
                </div> */}
                <div className="w-full flex flex-row justify-between items-center ">
                  <div className="p-3 gap-3 flex justify-center items-center">
                    <div className="flex justify-end items-end ">
                      <img
                        className="mr-5 w-24"
                        src={logoSmall}
                        alt="Yerlem"
                      />
                      <p
                        className="flex justify-center items-center"
                      >
                        Defterdar
                      </p>
                    </div>
                  </div>
                  <Button
                    onClick={() => {
                      logoutMerchant();
                    }}
                    startIcon={<Logout />}
                    variant="outlined"
                    className=" z-[0]"
                  >
                    {textPool['ÇIKIŞ YAP']}
                  </Button>
                </div>
              </div>
            </div>
          )}
          <div className="w-full">{children}</div>
        </div>
      </Drawer>
      <Modal open={modalOpen}>
        <Box
          style={{
            outline: 'none',
            position: 'absolute',
            top: '50%',
            left: '50%',
            borderRadius: 30,
            transform: 'translate(-50%, -50%)',
            width: 500,
            minHeight: 300,
            backgroundColor: 'white',
            boxShadow: 24,
            padding: 10,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
          }}
        >
          <Typography
            variant="h5"
            color="initial"
            gutterBottom
            textAlign={'center'}
          >
            {textPool['Hangi uygulamaya giriş yapmak istiyorsunuz?']}
          </Typography>

          <div className="flex flex-wrap w-full justify-center items-center mb-3">
            {instances.map((instance, index) => (
              <div
                key={index}
                className="flex flex-col w-36 justify-center items-center p-2 m-5 cursor-pointer hover:scale-110 transition ease 1s drop-shadow-2xl shadow-lg rounded-lg"
                onClick={() => handleInstanceSelection(instance)}
              >
                <span className="font-semibold m-5">{instance.name}</span>
              </div>
            ))}
          </div>
          <div className="flex justify-end items-center">
            <img className="mr-5 w-24" src={logoSmall} alt="Yerlem" />
          </div>
        </Box>
      </Modal>
    </>
  );
}

export default TDrawer;
